import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { formatNameProductCart } from '../../../../../constants/ecommerce/format-name-products-cart'
import { priceNormalize } from '../../../../../constants/ecommerce/format-prices'
import {
  AddButton,
  CardContainer,
  CardContainerLoader,
  CardIcon,
  ContentCta,
  ContentLeft,
  ContentRight,
  ContentTitle,
  DeleteItem,
  DeleteItemContainer,
  IconContainer,
  Price,
  PriceContainer,
  Quantity,
  SubstractButton,
} from './mixins'
import { addQuantityItem, removeItemToCart, subtractQuantityItem } from '../../../../../store/cart-v2/valorized/actionsToDo'
import { ItemCart, Params } from '../../../../../store/cart-v2/valorized/types'
import { StatusType } from '../../../../../store/typeStatus'
import MiniLoader from '../MiniLoader/index'
import CardLoader from '../CardLoader/index'
import { updateParamsCart } from '../../../../../store/cart-v2/valorized/actions'
import { AppStore } from '../../../../../store'
import { CouponState } from '../../../../../store/coupon/types'
import { useMetricEcommerce } from '../../../../../hooks/metrics/ecommerce-metrics-v2-hook'

interface ComponentProps {
  item: ItemCart
  status: StatusType
  index: number
  params: Params
}

const Component = ({ item, status, index, params }: ComponentProps) => {
  const dispatch = useDispatch()
  const { couponCode } = useSelector<AppStore, CouponState>(({ couponStore }) => couponStore)
  const { dispatchMetricCart } = useMetricEcommerce()
  const { t } = useTranslation()
  const { dataProduct, styled } = item
  const extraParams = { couponCode } // datos adicionales a la hora de valorizar, por ahora cupon de descuento

  /**
   * reseteamos valores seleccionados
   */

  useEffect(() => {
    dispatch(
      updateParamsCart({
        ...params,
        idProductSelected: 0,
        idProductRemoved: false,
      })
    )
  }, [dataProduct.quantity])

  const subtractQuantity = () => {
    dispatch(
      updateParamsCart({
        ...params,
        idProductSelected: dataProduct.productId,
      })
    )
    if (dataProduct.quantity > 1) {
      dispatch(subtractQuantityItem(item, extraParams))
      dispatchMetricCart.subtractQuantity({ productId: item.dataProduct.productId })
    }
  }

  const addQuantity = () => {
    dispatch(
      updateParamsCart({
        ...params,
        idProductSelected: dataProduct.productId,
      })
    )

    dispatch(addQuantityItem(item, extraParams))
    dispatchMetricCart.addQuantity({ productId: item.dataProduct.productId })
  }

  const removeProduct = () => {
    dispatch(
      updateParamsCart({
        ...params,
        idProductSelected: dataProduct.productId,
        idProductRemoved: true,
      })
    )

    dispatch(removeItemToCart(item, extraParams))
    dispatchMetricCart.removeItem({ productId: item.dataProduct.productId })
  }

  const icon = { name: 'icon-light-trash-2' }
  const buttonOptions = { size: 'medium', type: 'link', variant: 'black' }
  const { idProductSelected, idProductRemoved } = params
  const subtotaUnitPrice = dataProduct.unitPrice * dataProduct.quantity
  const disabledAction = status.loading && index === idProductSelected
  const itemRemoved = idProductRemoved && index === idProductSelected
  if (itemRemoved) {
    return (
      <CardContainerLoader>
        <CardLoader />
      </CardContainerLoader>
    )
  }
  return (
    <CardContainer>
      <IconContainer color={styled.color ?? ''}>
        <CardIcon name={styled.icon ?? ''} size="24" color="#FFF" />
      </IconContainer>
      <ContentLeft>
        <ContentTitle>
          {styled && formatNameProductCart({ tipo: styled.type, label: styled.label, creditos: styled.creditos, t })}
        </ContentTitle>
        <ContentCta>
          <SubstractButton
            onClick={() => {
              subtractQuantity()
            }}
            disabled={disabledAction || dataProduct?.quantity <= 1}
          >
            -
          </SubstractButton>
          {disabledAction ? <MiniLoader /> : <Quantity>{dataProduct?.quantity}</Quantity>}
          <AddButton
            disabled={disabledAction}
            onClick={() => {
              addQuantity()
            }}
          >
            +
          </AddButton>
        </ContentCta>
      </ContentLeft>
      <ContentRight>
        <DeleteItemContainer>
          <DeleteItem
            buttonoptions={buttonOptions}
            icon={icon}
            onClick={() => {
              removeProduct()
            }}
          />
        </DeleteItemContainer>
        <PriceContainer>
          <Price>{priceNormalize({ priceToNormalize: subtotaUnitPrice, showMinFractions: true })}</Price>
        </PriceContainer>
      </ContentRight>
    </CardContainer>
  )
}

export default Component
